<template>
  <div id="show-client-portal-mac-address-attributes">
    <v-card class="mt-3">
      <v-card-title>
        MAC autorisées
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              icon
              @click.stop="openDialog = true"
              v-bind="attrs"
              v-on="on"
              v-if="isGrantedUser()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Ajouter une adresse MAC</span>
        </v-tooltip>
        <create-mac-address-attribute-dialog
          :clientPortal="clientPortal"
          :open.sync="openDialog"
          v-if="openDialog && isGrantedUser()"
        ></create-mac-address-attribute-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <mac-address-datatable
          :macaddresses="macaddresses"
          :loading="isLoading"
          @refresh-data="listAttributes(clientPortal.id, 'MAC-ADDRESS')"
        ></mac-address-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, ref, toRefs } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import CreateMacAddressAttributeDialog from "@/components/Attribute/CreateMacAddressAttributeDialog";
import MacAddressDatatable from "@/components/Attribute/MacAddressDatatable";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
  },
  components: {
    MacAddressDatatable,
    CreateMacAddressAttributeDialog,
  },
  setup(props) {
    /* Import des API */
    const { macaddresses, listAttributes, attributeData } = useAttributes();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const openDialog = ref(false);

    /* Cycle de vie */
    onMounted(() => {
      listAttributes(props.clientPortal.id, "MAC-ADDRESS");
    });

    return {
      macaddresses,
      openDialog,
      ...toRefs(attributeData),
      listAttributes,
      isGrantedUser,
    };
  },
};
</script>
